// extracted by mini-css-extract-plugin
export default {"main":"CustomPhoneInput_main__t-l5E"};